/* eslint-disable import/no-unresolved */
import { useDispatch, useSelector } from 'react-redux';
import {
  Modal,
  Box,
  Typography,
  Slide,
  Backdrop,
  IconButton,
} from '@mui/material';
import SplitTableForm from '@/components/Forms/SplitTableForm';
import { selectModal } from '@/store/selectors';
import { closeModal } from '@/store/slices/modal';

const boxStyle = {
  position: 'absolute',
  height: '715px',
  width: '793px',
  backgroundColor: '#FAFAFA',
  borderRadius: '10px',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  margin: 'auto',
  textAlign: 'center',
  py: 4,
  px: 8,
};
const SplitTable = () => {
  const { splitTable } = useSelector(selectModal);
  const dispatch = useDispatch();

  const handleModalClose = () => {
    dispatch(closeModal({ type: 'splitTable' }));
  };

  return (
    <div>
      <Modal
        open={splitTable}
        onClose={handleModalClose}
        aria-labelledby="logout-modal-title"
        aria-describedby="logout-modal-description"
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Slide direction="up" in={splitTable} mountOnEnter unmountOnExit>
          <Box sx={boxStyle}>
            <Box sx={{ textAlign: 'left', marginBottom: 6 }}>
              <IconButton
                onClick={handleModalClose}
                sx={{
                  width: '92px',
                  height: '40px',
                  borderRadius: '90px',
                  p: '12px 16px',
                  position: 'absolute',
                  left: 0,
                  top: '10px',
                }}
              >
                <Typography
                  sx={{
                    fontWeight: 600,
                    marginLeft: 1,
                    fontFamily: 'Montserrat',
                    color: (theme) => theme.palette.primary.main,
                  }}
                >
                  Close
                </Typography>
              </IconButton>
            </Box>
            <Typography
              variant="h4"
              sx={{
                lineHeight: '15px',
                fontWeight: 600,
                textAlign: 'center',
                fontSize: '20px',
                fontFamily: 'Montserrat',
                color: (theme) => theme.palette.primary.main,
              }}
            >
              Input Quantity to be moved
            </Typography>
            <SplitTableForm />
          </Box>
        </Slide>
      </Modal>
    </div>
  );
};

export default SplitTable;
